module.exports = __webpack_public_path__ + "img/seminar-1997.eac954d2.jpg";